import React from 'react'

import validation from '../../../validation'

import AppointmentNotesSection from './AppointmentNotesSection'
import AttorneySection from './AttorneySection'
import DiagnosisSection from './DiagnosisSection'
import DiagnosticTestsSection from './DiagnosticTestsSection'
import EquipmentSection from './EquipmentSection'
import FunctionalSection from './FunctionalSection'
import HomeSetupSection from './HomeSetupSection'
import InjurySection from './InjurySection'
import MedicationsSection from './MedicationsSection'
import MMISection from './MMISection'
import PharmaciesSection from './PharmaciesSection'
import PhysicianReviewerSection from './PhysicianReviewerSection'
import ReferralSection from './ReferralSection'
import SurgeriesAndHospitalizationsSection from './SurgeriesAndHospitalizationsSection'
import SystemsSection from './SystemsSection'
import TranslationSection from './TranslationSection'
import TransportationSection from './TransportationSection'
import TreatmentProvidersSection from './TreatmentProvidersSection'
import WorkStatusSection from './WorkStatusSection'

const sections = [
  // ── Claimant ─────────────────────────────────────────────────── (top, per UX request)
  ReferralSection,
  AttorneySection,

  // ── Case Details ─────────────────────────────────────────────────────────────────────
  InjurySection,
  DiagnosisSection,
  MedicationsSection,
  SurgeriesAndHospitalizationsSection,
  SystemsSection,
  FunctionalSection,
  MMISection,
  WorkStatusSection, // moved under MMI; group changed from 'Notes & Time' to 'Case Details'
  DiagnosticTestsSection,
  EquipmentSection,
  HomeSetupSection,

  // ── Providers ────────────────────────────────────────────────────────────────────────
  TransportationSection,
  TranslationSection,
  TreatmentProvidersSection,
  PharmaciesSection,
  PhysicianReviewerSection,

  // ── Hidden from sidebar nav (#340) ────────────────────────────────────────────────
  // AppointmentNotesSection is kept in the array so ?section=N navigation still works.
  // A "Completed Appointments" button in DetailsPage links to its originalIndex.
  // TasksSection removed entirely — completed tasks are now on the Case Overview tab.
  AppointmentNotesSection,
]

if (new URLSearchParams(window.location.search).get('showModel')) {
  sections.push({
    name: 'Model',
    group: 'Diagnostics',
    validationSchema: validation.object({}),
    Component: ({ caseModel }) => (
      <div>
        <pre>{JSON.stringify(caseModel, null, 2)}</pre>
      </div>
    ),
  })

  sections.push({
    name: 'Validations',
    group: 'Diagnostics',
    validationSchema: validation.object({}),
    Component: ({ validStateBySection }) => (
      <div>
        <pre>{JSON.stringify(validStateBySection, null, 2)}</pre>
      </div>
    ),
  })

  sections.push({
    name: 'Named State',
    group: 'Diagnostics',
    validationSchema: validation.object({}),
    Component: ({ namedState }) => (
      <div>
        <pre>{JSON.stringify(namedState, null, 2)}</pre>
      </div>
    ),
  })

  sections.push({
    name: 'Other',
    group: 'Diagnostics',
    validationSchema: validation.object({}),
    Component: ({ modelIsDirty }) => (
      <div>
        <div>
          <label htmlFor="nothing">Is Model Dirty?</label>{' '}
          {modelIsDirty ? <span className="text-danger">Yes</span> : <span>No</span>}
        </div>
      </div>
    ),
  })
}

export default sections
